// 截取url参数
export function getUrlKey(name) {
    var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
    var search = window.location.search,
        hash = window.location.hash;
    var r = search ?
            search.substring(1).match(reg) :
            hash.substring(hash.indexOf('?')+1).match(reg)
    if(r!=null)return decodeURIComponent(r[2]); return null;
}

export default getUrlKey;


// WEBPACK FOOTER //
// ./src/utils/tools.js